"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _container = _interopRequireDefault(require("../container"));

var _anglePatternInline = _interopRequireDefault(require("./angle-pattern.inline.svg"));

var _index = _interopRequireDefault(require("./index.scss"));

var PreHeader = function PreHeader(_ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      colour = _ref.colour;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_index["default"].PreHeader, className, (_classNames = {}, (0, _defineProperty2["default"])(_classNames, _index["default"].seasonal, colour === 'seasonal'), (0, _defineProperty2["default"])(_classNames, _index["default"].minimal, colour === 'minimal'), (0, _defineProperty2["default"])(_classNames, _index["default"].brand, colour === 'brand'), (0, _defineProperty2["default"])(_classNames, _index["default"].black, colour === 'black'), _classNames)),
    role: "banner"
  }, _react["default"].createElement(_anglePatternInline["default"], {
    "aria-hidden": "true"
  }), _react["default"].createElement(_container["default"], {
    className: _index["default"].container,
    type: "large"
  }, children));
};

PreHeader.propTypes = {
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.node), _propTypes.node]),
  className: _propTypes.string,
  colour: (0, _propTypes.oneOf)(['brand', 'minimal', 'seasonal', 'black'])
};
PreHeader.defaultProps = {
  children: [],
  className: null,
  colour: 'seasonal'
};
var _default = PreHeader;
exports["default"] = _default;